<template>
	<LazyLoadWrapper>
		<div
			v-editable="blok"
			class="w-full flex lg:flex-nowrap flex-wrap justify-between items-center lg:flex-row flex-col my-14 main-wrapper"
		>
			<div
				class="w-full lg:order-none order-1 lg:w-6/12 py-[52px] pr-7 pl-[52px] flex flex-grow flex-col justify-center items-center lg:items-start text-gray-900 bg-gray-300"
			>
				<h2 class="mb-2 text-base uppercase tracking-wider font-semibold">
					{{ blok.headline }}
				</h2>
				<h3 class="mb-3 text-3xl">
					{{ blok.sub_heading }}
				</h3>
				<p class="mb-8 text-base">
					{{ blok.text }}
				</p>

				<StoryblokComponent
					v-for="call_to_action in blok.call_to_action"
					:key="call_to_action._uid"
					:blok="call_to_action"
				/>
			</div>
			<div class="w-full lg:w-auto flex justify-center lg:justify-end">
				<StoryblokComponent
					v-for="image in blok.image"
					:key="image._uid"
					:blok="image"
					image-size="592"
					extra-classes="max-h-[494px] object-cover rounded"
				/>
			</div>
		</div>
	</LazyLoadWrapper>
</template>

<script setup lang="ts">
import type { BlokFeaturedCampaign } from "~/types/storyblok/storyblok";
import LazyLoadWrapper from "~/components/LazyLoadWrapper.vue";

interface Props {
	blok: BlokFeaturedCampaign;
}

const { blok } = defineProps<Props>();
</script>
